export const getBoxColor = (id, satSpecs) => {  
  const spectralType = satSpecs[id].spectral_range;
  switch (spectralType) {
    case "MS":
      return "rgba(255, 51, 51, 0.2)";
    case "SAR":
      return "rgba(102, 255, 102, 0.2)";
    case "RGB":
      return "rgba(51, 102, 255, 0.15)" ;
    case "RGB, NIR":
      return "rgba(204, 51, 204, 0.1)";
    default:
      return "rgba(255, 255, 255, 1)";
    }
  };
  
  export const getStrokeColor = (id, satSpecs) => {
    const spectralType = satSpecs[id].spectral_range;
    switch (spectralType) {
      case "MS":
        return "rgba(255, 51, 51, 1)";
      case "SAR":
        return "rgba(102, 255, 102, 1)";
      case "RGB":
        return "rgba(51, 102, 255, 1)" ;
      case "RGB, NIR":
        return "rgba(204, 51, 204, 1)";
      default:
        return "rgba(0, 0, 0, 1)";
    }
  };